
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    //export class ProductsFranchiseeDialog extends Serenity.PropertyDialog<any, any> {
    export class AssignEnquiryDialog extends Serenity.EntityDialog<EnquiryRow, any> {
        protected getFormKey() { return AssignEnquiryForm.formKey; }
        protected getIdProperty() { return EnquiryRow.idProperty; }
        protected getLocalTextPrefix() { return EnquiryRow.localTextPrefix; }
        protected getService() { return EnquiryService.baseUrl; }

        protected form = new AssignEnquiryForm(this.idPrefix);
        public rowids: string;

        private checkGrid: EnquiryGrid;
        constructor(gridToRefresh, FormMode, selectedids) {
            super();
            this.form = new AssignEnquiryForm(this.idPrefix);
            this.rowids = selectedids;
            this.form.OrderIds.value = this.rowids;
        }

        loadEntity(entity: EnquiryRow) {
            super.loadEntity(entity);
            this.form.OrderIds.value = this.rowids;

           
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();
            //debugger;
            buttons.splice(0,6);
           
          

          

            return buttons;
        }
        protected getDialogButtons(): Serenity.DialogButton[] {
            return [

                {
                    text: 'Assign Enquiry',
                    click: () => {
                        //debugger;
                        //if (!this.validateBeforeSave())
                        //    return;

                        //if (this.form.CourseId.value == null || Q.isEmptyOrNull(this.form.CourseId.value)) {
                        //    Q.notifyError("Please enter a value!");
                        //    return;
                        //}
                        if (this.form.HandledBy.value == null ||
                            Q.isEmptyOrNull(this.form.HandledBy.value)) {
                            Q.notifyError("Please select a Agent!");
                            return;
                        }
                        var id = this.form.OrderIds.value;
                        var id2 = this.rowids;

                        EnquiryService.AssignAgent({
                            ids: this.form.OrderIds.value,
                            HandledBy:Number(this.form.HandledBy.value)


                        }, response => {
                            //debugger;
                          
                            //debugger;
                            Q.notifySuccess("Enquiry Assigned Successfully");
                            //if (response.ErrorList != null && response.ErrorList.length > 0) {
                            //    //Q.notifyError(response.ErrorList.join(',\r\n '));
                            //    Q.notifyError("No of Invalid data count.!" + response.ErrorList.length + "Please search 'Error' on Search");
                            //    alert("No of Invalid data count.!" + response.ErrorList.length + "Please search 'Error' on Search");
                            //}

                            this.dialogClose();
                            // this.checkGrid.rowSelection.resetCheckedAndRefresh();
                            // this.checkGrid.refresh();
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }

        protected getDialogTitle(): string {
            return "Assign Enquiry";
        }
    }
}